import { Controller } from "@hotwired/stimulus";
import React from "react";
import ReactDOM from "react-dom/client"; 
import App from "../components/App"; 

export default class extends Controller {
  connect() {
    const app = document.getElementById("app");

    if (app) {
      const root = ReactDOM.createRoot(app); // Create root for React 18+
      root.render(<App />);
    } else {
      console.error("App container not found.");
    }
  }
}
